import React, {Component} from 'react';
import {Dimmer, Loader, Grid, Header, Segment, Icon} from 'semantic-ui-react';
import _ from 'lodash';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {connect} from 'react-redux';
import {commonJwtHeader} from 'common/utils';
import Error from 'app-ui-componentlibrary/dist/go/components/common/error';
import {connectWithCore} from 'framework/hocs';
import REST from 'go/requests/rest';
import {downloadPresignedLink, usePresignedUrl} from 'common/utils';
import {forceJsonResponse, MONO, FLUX} from 'common/utils';
export class RiskProfile extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      riskProfile: [],
      attachments: [],
      riskData: [],
      loading: true,
      dataSynced: false,
    };
  }

  componentDidUpdate() {
    const {riskProfile, attachments, loading, dataSynced} = this.state;
    const riskData = [];
    if (loading === false && dataSynced === false) {
      _.forEach(riskProfile, (assessment) => {
        var match = _.find(
          attachments,
          (file) => String(file.entityId) === String(assessment.riskAssessmentId)
        );
        var obj = _.clone(assessment);
        if (match) {
          obj.resourceId = match.resourceId;
          obj.fileName = match.fileName;
        }
        riskData.push(obj);
      });
      this.setState({riskData: riskData, dataSynced: true});
    }
  }
  downloadAttachmentLink = (resourceId, fileName) => {
    if (usePresignedUrl()) {
      return (
        <a
          href="#"
          onClick={() => {
            downloadPresignedLink(resourceId);
          }}
          title={`Download ${fileName}`}
        >
          {fileName}
        </a>
      );
    } else {
      const downloadUrl = REST.attachment.getAttachmentDownloadUrl(resourceId);
      return (
        <a href={downloadUrl} title={`Download ${fileName}`}>
          {fileName}
        </a>
      );
    }
  };
  UNSAFE_componentWillMount() {
    const {organizationId, riskAssessment, programId, jwt} = this.props;
    const requestParams = {
      method: 'GET',
      headers: commonJwtHeader(jwt),
    };
    let attachmentUrl;

    if (organizationId && programId) {
      REST.organization
        .getRiskAssessentByOrgId(jwt, programId, organizationId)
        .then((response) => {
          if (response.status === 404) return [];
          // TODO, non-standard handler
          else return forceJsonResponse(response, FLUX);
        })
        .then((responseJson) => {
          this.setState({riskProfile: responseJson});
          return Promise.all(
            _.map(responseJson, (riskAssessment) =>
              REST.attachment.getAttachmentsByEntityIdAndEntityType(
                jwt,
                riskAssessment.riskAssessmentId,
                'riskAttachment'
              )
            )
          );
        })
        .then((response) => {
          return Promise.all(
            _.map(response, (item) => {
              if (item.status === 404 || item.status === 401) return [];
              else return item.json();
            })
          );
        })
        .then((responseJson) => {
          this.setState({
            attachments: _.flatten(responseJson),
            loading: false,
          });
        })
        .catch((error) => {
          console.error('error');
          this.setState({
            loading: false,
            error: true,
          });
        });
    } else if (riskAssessment && programId) {
      this.setState({riskProfile: [riskAssessment]});
      REST.attachment
        .getAttachmentsByEntityIdAndEntityType(
          jwt,
          riskAssessment.riskAssessmentId,
          'riskAttachment'
        )
        .then((response) => {
          if (response.status === 404) return [];
          else return forceJsonResponse(response, FLUX);
        })
        .then((responseJson) => {
          this.setState({attachments: responseJson, loading: false});
        })
        .catch((error) => {
          console.error('error');
          this.setState({
            loading: false,
            error: true,
          });
        });
    } else this.setState({loading: false});
  }
  renderSuccesfulRow(riskDataArray) {
    const {routerLocation = {}} = this.props;
    return (
      <FemaGoTable type="static" summary="Risk profile">
        <FemaGoTable.Header>
          <FemaGoTable.Row>
            <FemaGoTable.HeaderCell>Funding opportunity</FemaGoTable.HeaderCell>
            <FemaGoTable.HeaderCell>Grant ID</FemaGoTable.HeaderCell>
            <FemaGoTable.HeaderCell>Reviewer</FemaGoTable.HeaderCell>
            <FemaGoTable.HeaderCell>Risk assessment</FemaGoTable.HeaderCell>
            <FemaGoTable.HeaderCell>Comment</FemaGoTable.HeaderCell>
            <FemaGoTable.HeaderCell>Attachment</FemaGoTable.HeaderCell>
          </FemaGoTable.Row>
        </FemaGoTable.Header>
        <FemaGoTable.Body>
          {_.map(riskDataArray, (riskData, index) => {
            const {
              fundingOpportunity,
              reviewerName,
              riskComments,
              riskLevel,
              fileName,
              resourceId,
              grantId,
            } = riskData;

            const newLocation = _.chain(window.location.href)
              .replace(routerLocation.search, '')
              .replace(routerLocation.hash, '')
              .replace(routerLocation.pathname, '/grant/' + grantId)
              .value();

            return (
              <FemaGoTable.Row key={riskData.riskAssessmentId + index}>
                <FemaGoTable.TextCell width={3}>
                  {fundingOpportunity}
                </FemaGoTable.TextCell>
                <FemaGoTable.TextCell width={3}>
                  <a
                    href={newLocation}
                    target="_blank"
                    title={`${grantId}, row number: ${index}`}
                  >
                    {grantId}
                    <Icon name="external alternate" />
                  </a>
                </FemaGoTable.TextCell>
                <FemaGoTable.TextCell width={2}>{reviewerName}</FemaGoTable.TextCell>
                <FemaGoTable.TextCell width={2}>{riskLevel}</FemaGoTable.TextCell>
                <FemaGoTable.TextCell>{riskComments}</FemaGoTable.TextCell>
                <FemaGoTable.TextCell width={3}>
                  {this.downloadAttachmentLink(resourceId, fileName)}
                </FemaGoTable.TextCell>
              </FemaGoTable.Row>
            );
          })}
        </FemaGoTable.Body>
      </FemaGoTable>
    );
  }

  renderNoData() {
    return (
      <React.Fragment>
        There are no previous risk assessments for this applicant in FEMA GO.
      </React.Fragment>
    );
  }

  renderAvailable = (riskDataFlag, riskData) => {
    return (
      <React.Fragment>
        {(riskDataFlag === undefined || !riskDataFlag) && this.renderNoData()}
        {riskDataFlag && this.renderSuccesfulRow(riskData)}
      </React.Fragment>
    );
  };

  render() {
    let {error} = this.state;

    if (error) {
      return <Error />;
    } else {
      const riskDataFlag = this.state.riskData.length > 0;
      return (
        <React.Fragment>
          <Header as="h1" id={this.props.id}>
            Risk profile
          </Header>
          <Segment>
            <Header as="h2">Assessments for other funding opportunities</Header>
            {!this.state.loading ? (
              this.renderAvailable(riskDataFlag, this.state.riskData)
            ) : (
              <Dimmer active inverted>
                <Loader inverted />
              </Dimmer>
            )}
          </Segment>
        </React.Fragment>
      );
    }
  }
}

export const mapStateToProps = (state) => {
  return {
    jwt: state.auth.token,
    routerLocation: state.router.location,
  };
};

export default connect(mapStateToProps)(connectWithCore(RiskProfile));
